import * as React from 'react';
import { Link } from 'react-router';
import styled, { withTheme } from 'styled-components';
import { rem, darken } from 'polished';
import { TextP } from '../../Defaults/Text';
import { FlexCol, FlexBetween } from '../../Defaults/Flexbox/Flexbox';
import { __ } from 'react-i18n';
import { TableTd, TableRow, DefaultTableTd } from '../../Zemplin/General/Table';
import {
  getInvoiceDetailInfo,
  getOrderRowInfo,
} from '../../../utilities/selectors';
import {
  formatDate,
  formatPrice,
  getOrderColor,
  prop,
} from '../../../utilities';
import { IconImg } from '../../..';

export interface Props {
  order?: any;
  theme: any;
  status: boolean;
  downloadFile: any;
  currency: string;
}

function InvoiceRow({ order, theme, status, downloadFile, currency }: Props) {
  if (!order) {
    return null;
  }

  const handleDownloadFile = () => {
    downloadFile(order);
  };

  const notPaidSum = prop(order, 'outer_payload.NeuhradeneEur', 0);
  const hasTooMuchPaid = notPaidSum < 0;
  const fullSum = prop(order, 'outer_payload.CenaCelkomEur', 0);
  const sumDifference = fullSum - notPaidSum;
  const showNotPaidSum =
    hasTooMuchPaid || (notPaidSum > 0 && sumDifference > 0);

  return (
    <StyledTableRow>
      <StyledTableTd>
        <StatusText>
          {prop(order, 'outer_payload.DruhDokladu', 'Faktúra')}
        </StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText>
          {prop(order, 'outer_payload.HeliosNumber') ||
            order.helios_document_id}
        </StatusText>
      </StyledTableTd>
      <StyledTableTd>
        <StatusText>
          {formatDate(order.outer_payload.DatPripad, 'DD-MM-YYYY')}
        </StatusText>
      </StyledTableTd>
      <StyledTableTd>
        {' '}
        <StatusText>
          {formatDate(order.outer_payload.DatSplatnost, 'DD-MM-YYYY')}
        </StatusText>
      </StyledTableTd>
      <StyledTableTd>
        {' '}
        <StyledStatusText status={order.paid || hasTooMuchPaid ? 1 : 0}>
          {/* {`${
            hasTooMuchPaid
              ? 'Preplatok'
              : order.paid
              ? 'Uhradená'
              : sumDifference > 0
              ? 'Nedoplatok'
              : 'Neuhradená'
          }`} */}
          {`${order.paid || hasTooMuchPaid ? 'Uhradená' : 'Neuhradená'}`}
          <br />
          {/* {showNotPaidSum &&
            ` (${hasTooMuchPaid ? '+' : `${__('neuhradených')} `}`}
          {showNotPaidSum && formatPrice(-notPaidSum, 'EUR')}
          {showNotPaidSum && ')'} */}
        </StyledStatusText>
      </StyledTableTd>
      {order && order.invoice_pdf_document_id ? (
        <StyledTableTdCenter>
          {' '}
          <StyledButton
            onClick={handleDownloadFile}
            // align={'center'}
            // href={`${process.env.REACT_APP_API_BASE_URL}${order.link}`}
            // target="_blank"
          >
            <IconImg
              cursor={'pointer'}
              width={24}
              height={24}
              src={'/assets/dsi/download.svg'}
            />
          </StyledButton>
        </StyledTableTdCenter>
      ) : (
        <StyledTableTdCenter>{' Nieje k dispozícií '}</StyledTableTdCenter>
      )}
      <StyledTableTd>
        <StatusText
          title={
            hasTooMuchPaid
              ? 'Preplatok'
              : order.paid
              ? 'Uhradená'
              : sumDifference > 0
              ? 'Nedoplatok'
              : 'Neuhradená'
          }
          align={'right'}
        >
          {showNotPaidSum
            ? formatPrice(notPaidSum, 'EUR')
            : formatPrice(prop(order, 'outer_payload.CenaCelkomEur'), 'EUR')}
        </StatusText>
      </StyledTableTd>
    </StyledTableRow>
  );
}

const StyledTableTd = styled(TableTd)<{ align: boolean }>`
  padding: ${rem(16)} ${rem(24)};
  border-bottom: ${({ theme }) => theme.borders.primary};
`;

const StyledTableTdCenter = styled(StyledTableTd)`
  text-align: center;
`;

const StyledTableRow = styled(TableRow)`
  padding: ${rem(24)} 0;
  border-top: ${({ theme }) => theme.borders.primary};
  background-color: ${({ theme }) => theme.colors.white};
  &:last-child {
    border-bottom: ${({ theme }) => theme.borders.primary};
  }
`;

const StatusText = styled(TextP)<{ align?: string }>`
  font-size: ${rem(16)};
  line-height: ${rem(22)};
  color: ${({ theme }) => theme.colors.textPrimary};
  font-weight: 400;
  text-align: ${({ align }) => (align ? align : 'left')};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const StyledStatusText = styled(StatusText)<{ status?: number }>`
  color: ${({ theme, status }) =>
    status === 1
      ? theme.colors.successColor
      : status === -1
      ? theme.colors.stockCountWarning
      : theme.colors.dangerColor};
  font-weight: 500;
`;

const StyledButton = styled.button`
  border: 0;
  background: transparent;
`;

const WithThemeRow: any = withTheme(InvoiceRow);
export { WithThemeRow as InvoiceRow, StyledTableRow };
